import { render } from "./k8s.cni.cncf.io.networkattachmentdefinition.vue?vue&type=template&id=98f4dc78"
import script from "./k8s.cni.cncf.io.networkattachmentdefinition.vue?vue&type=script&lang=js"
export * from "./k8s.cni.cncf.io.networkattachmentdefinition.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__